<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :xl="22" :lg="22" :offset="1" class="page-title">Vendor Maintenance</el-col>
      <el-col :xl="3" :lg="4" :offset="1" class="margin-top margin-bottom">
        <el-form label-position="top" :model="vendorSearchInfo" ref="searchForm">
          <el-form-item label="Vendor Code">
            <el-input v-model="vendorSearchInfo.vendorCode"></el-input>
          </el-form-item>
          <el-form-item label="Vendor Name">
            <el-input v-model="vendorSearchInfo.vendorName"></el-input>
          </el-form-item>
          <el-form-item label="Contact Person">
            <el-input v-model="vendorSearchInfo.contactPerson"></el-input>
          </el-form-item>
          <el-form-item prop="email" label="Email"
                        :rules="[{ type: 'email', message: incorrectEmailMsg, trigger: ['blur', 'change'] }]">
            <el-input v-model="vendorSearchInfo.email" onKeypress="if(event.keyCode == 32) event.returnValue = false"></el-input>
          </el-form-item>
          <el-form-item label="Category">
            <el-select v-model="vendorSearchInfo.categoryId" filterable placeholder="PLEASE SELECT">
              <el-option
                v-for="(item,index) in categoryListForSearch"
                :key="index"
                :label="item.categoryName"
                :value="item.categoryId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Region">
            <el-select v-model="vendorSearchInfo.region" filterable :disabled="this.regionListForSearch.length===2 ?true:false" placeholder="PLEASE SELECT">
              <el-option
                v-for="(item,index) in regionListForSearch"
                :key="index"
                :label="item.regionName"
                :value="item.regionValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Associated Staff">
            <el-select v-model="vendorSearchInfo.gsid" filterable :disabled="gsidListForSearch.length===2 ?true:false" placeholder="PLEASE SELECT">
              <el-option
                v-for="(item,index) in gsidListForSearch"
                :key="index"
                :label="item.gsidName"
                :value="item.gsidValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Company">
            <el-select v-model="vendorSearchInfo.company" filterable :disabled="this.companyListForSearch.length===2 ?true:false" placeholder="PLEASE SELECT">
              <el-option
                v-for="(item,index) in companyListForSearch"
                :key="index"
                :label="item.companyName"
                :value="item.companyValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Status">
            <el-select v-model="vendorSearchInfo.required" placeholder="PLEASE SELECT">
              <el-option value="" label="<ALL>">ALL</el-option>
              <el-option :value="1" label="Active">Active</el-option>
              <el-option :value="0" label="Inactive">Inactive</el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="danger" class="search-btn" @click="searchValidateAndCall">Search</el-button>
      </el-col>
      <el-col :xl="1" :lg="1" class="margin-top">
        <div class="line"></div>
      </el-col>
      <el-col :xl="18" :lg="17" class="margin-top">
        <el-button @click="showAddDialog">Add</el-button>
        <el-button @click="showModifyDialog">Modify</el-button>
        <el-button @click="uploadDialogVisible = true">Upload</el-button>
        <el-button @click="exportTableData">Export</el-button>
        <el-table class="vendor-table" empty-text="No Data" :data="vendorInfoList"
                  ref="multipleTable" stripe @row-dblclick="handleRowDBClick" max-height="700"
                  style="width: 100%" highlight-current-row @selection-change="handleSelectionChange" :default-sort = "{prop: 'vendorCode', order: 'ascending'}"
                  v-loading="loadingStatus">
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="Vendor Code" sortable prop="vendorCode" align="center" width="135">
            <template slot-scope="scope">
              <span>{{scope.row.vendorCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Vendor Name" sortable prop="vendorName" align="center" width="135">
            <template slot-scope="scope">
              <span>{{scope.row.vendorName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Contact Person" sortable prop="contactPerson" align="center" width="150">
            <template slot-scope="scope">
              <span>{{scope.row.contactPerson}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Vendor Email" prop="email" sortable align="center" width="140">
            <template slot-scope="scope">
              <span>{{scope.row.email}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Category" sortable prop="categoryName" :show-overflow-tooltip="true" align="center" width="110">
            <template slot-scope="scope">
              <span>{{scope.row.categoryName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Region" sortable prop="regionAccountId" :show-overflow-tooltip="true" align="center" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.region}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Associated Staff" sortable prop="displayName" :show-overflow-tooltip="true" align="center" width="160">
            <template slot-scope="scope">
              <span>{{scope.row.displayName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Company" sortable prop="company" :show-overflow-tooltip="true" align="center" width="110">
            <template slot-scope="scope">
              <span>{{scope.row.company}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Active" align="center" width="65" >
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.required" disabled></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="Last Updated By" sortable prop="modifiedBy" align="center" width="170">
            <template slot-scope="scope">
              <span>{{scope.row.modifiedBy}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Last Updated Date" sortable prop="modifiedDate" width="170">
            <template slot-scope="scope">
              <span v-if="scope.row.newModifiedDate !== null">{{scope.row.newModifiedDate}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="table-nav" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" background
                       :page-sizes="[20,40, 100, 200, 500]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close='closeDialog' width="500px" top="100px">
          <el-form label-position="top" :model="updateVendorInfo" :rules="rules" class="dialog-form" ref="updateForm">
            <el-form-item label="Vendor Code">
              <el-input v-model="updateVendorInfo.vendorCode"></el-input>
            </el-form-item>
            <el-form-item label="Vendor Name" prop="vendorName">
              <el-input v-model="updateVendorInfo.vendorName"></el-input>
            </el-form-item>
            <el-form-item label="Contact Person" prop="contactPerson">
              <el-input v-model="updateVendorInfo.contactPerson"></el-input>
            </el-form-item>
            <el-form-item label="Email" prop="email">
              <el-input type="email" v-model="updateVendorInfo.email" onKeypress="if(event.keyCode == 32) event.returnValue = false"></el-input>
            </el-form-item>
            <el-form-item label="Category" prop="categoryId">
              <el-select v-model="updateVendorInfo.categoryId" filterable placeholder="PLEASE SELECT">
                <el-option
                  v-for="(item,index) in categoryObjectList"
                  :key="index"
                  :label="item.categoryName"
                  :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Company" prop="company">
              <el-select v-model="updateVendorInfo.company"  @change="chooseCompany" filterable  :disabled="companyObjectList.length===1 ?true:false">
                <el-option
                  v-for="(item,index) in companyObjectList"
                  :key="index"
                  :label="item.companyName"
                  :value="item.companyValue">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Region" prop="region" >
              <el-select v-model="updateVendorInfo.region" @change="chooserRegion" filterable :disabled="regionObjectList.length===1 ?true:false">
                <el-option
                  v-for="(item,index) in regionObjectList"
                  :key="index"
                  :label="item.regionName"
                  :value="item.regionValue">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Associated Staff" prop="gsid">
              <el-select v-model="updateVendorInfo.gsid" @change="chooserGsid" filterable :disabled="gsidObjectList.length===1 ?true:false">
                <el-option
                  v-for="(item,index) in gsidObjectList"
                  :key="index"
                  :label="item.gsidName"
                  :value="item.gsidValue">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Active" prop="required">
              <el-select v-model="updateVendorInfo.required" @change="chooserRequired">
                <el-option
                  v-for="(item,index) in requiredObjectList"
                  :key="index"
                  :label="item.requiredName"
                  :value="item.requiredValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancelBtn">Cancel</el-button>
            <el-button type="danger" @click="handleSaveVendor">Save</el-button>
          </span>
        </el-dialog>
        <el-dialog title="Upload Vendor Information" :visible.sync="uploadDialogVisible" width="30%" center>
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="vendorUploadUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :before-upload="validateFileType"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-progress="handleOnProgress"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :headers="{'Authentication-Token': jwtToken}"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="danger" plain>Select File</el-button>
            <el-button style="margin-left: 10px;" size="small"  @click="submitUpload" plain>Upload</el-button>
            <div slot="tip" class="el-upload__tip">Only Support for Excel File.</div>
          </el-upload>
        </el-dialog>
      </el-col>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import { saveVendorInfo, findVendorInfoByConditions } from '@/services/vendor.service';
import { findAllCategory } from '@/services/vendorCategory.service';
import { findAll } from '@/services/regionAccount.service';
import Constant from '@/common/Constant';
import CookiesHelper from '@/utils/cookiesHelper';
import getBaseUrl from '@/utils/apiBaseUrlHelper';
import CommonHelper from '@/utils/commonHelper';
import { verifyUserInfo } from '@/services/login.service'

export default {
  components: {
    Footer,
    Header
  },
  data () {
    return {
      fileList: [],
      vendorInfoList: [],
      vendorSearchInfo: {
        pageSize: 20,
        currentPage: 1,
        vendorCode: '',
        vendorName: '',
        contactPerson: '',
        email: '',
        categoryId: '',
        region: '',
        company: '',
        gsid: '',
        required: ''
      },
      dialogVisible: false,
      uploadDialogVisible: false,
      noEmailMsg: Constant.INPUT_EMAIL,
      incorrectEmailMsg: Constant.ENTER_CORRECT_EMAIL,
      vendorUploadUrl: `${getBaseUrl()}/esg/security/vendor/upload`,
      multipleSelection: [],
      updateVendorInfo: {
        id: '',
        vendorCode: '',
        vendorName: '',
        email: '',
        contactPerson: '',
        categoryId: '',
        region: '',
        company: '',
        gsid: '',
        required: '1'
      },
      dialogTitle: '',
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      loadingStatus: false,
      rules: {
        vendorCode: [
          { required: true, message: Constant.INPUT_VENDOR_CODE, trigger: ['blur', 'change'] }
        ],
        vendorName: [
          { required: true, message: Constant.INPUT_VENDOR_NAME, trigger: ['blur', 'change'] }
        ],
        email: [
          { required: true, message: Constant.INPUT_EMAIL, trigger: 'blur' },
          { type: 'email', message: Constant.ENTER_CORRECT_EMAIL, trigger: ['blur', 'change'] }
        ],
        contactPerson: [
          { required: true, message: Constant.INPUT_CONTACT_PERSON, trigger: ['blur', 'change'] }
        ],
        categoryId: [
          { required: true, message: Constant.INPUT_CATEGORY, trigger: ['blur', 'change'] }
        ],
        company: [
          { required: true, message: Constant.INPUT_COMPANY, trigger: ['blur', 'change'] }
        ],
        region: [
          { required: true, message: Constant.INPUT_REGION, trigger: ['blur', 'change'] }
        ],
        gsid: [
          { required: true, message: Constant.INPUT_ASSOCIATED_STAFF, trigger: ['blur', 'change'] }
        ],
        required: [
          { required: true, message: Constant.INPUT_ACTIVE, trigger: ['blur', 'change'] }
        ]
      },
      jwtToken: CookiesHelper.get('JWT-TOKEN-HEADER'),
      categoryObjectList: [],
      categoryObjects: {},
      companyObjectList: [],
      companyObjects: {},
      regionObjectList: [],
      regionObjects: {},
      gsidObjectList: [],
      gsidObjects: {},
      requiredObjectList: [],
      requiredObjects: {},
      regionAccount: '',
      vendorCategory: '',
      userType: '',
      userName: '',
      regionVendor: Constant.USER_TYPE_REGION_VENDOR,
      regionListForSearch: [],
      companyListForSearch: [],
      gsidListForSearch: [],
      categoryListForSearch: [],
      modifyFlag: false
    }
  },
  methods: {
    async callVendorInfo () {
      this.$loading({fullscreen: true});
      let categoryInfo = await findAllCategory();
      this.initCategoryData(categoryInfo);
      this.vendorCategory = categoryInfo;
      let regionAccountInfo = await findAll();
      if (regionAccountInfo != null) {
        this.regionAccount = regionAccountInfo;
        this.initSearchForm(regionAccountInfo);
        this.initRegionAccountData(regionAccountInfo);
      }
      this.$loading({fullscreen: true}).close();
    },
    initPageData (responseData) {
      this.vendorInfoList = [];
      responseData.forEach(item => {
        item.required = item.required === '1';
        if (item.esgVendorCategory != null) {
          item.categoryName = item.esgVendorCategory.categoryName;
        }
        if (item.esgVendorRegionalAccounts != null) {
          item.company = item.esgVendorRegionalAccounts.company;
          item.region = item.esgVendorRegionalAccounts.region
          if (item.esgVendorRegionalAccounts.esgStaffInfo) {
            item.newModifiedDate = CommonHelper.formatDate(item.modifiedDate);
            item.displayName = item.esgVendorRegionalAccounts.esgStaffInfo.displayName;
          }
        }
        this.vendorInfoList.push(item);
      });
    },
    initSearchForm (regionAccountInfo) {
      let regionSet = new Set();
      let companySet = new Set();
      let gsidMap = new Map();
      let categoryMap = new Map();
      regionAccountInfo.data.forEach(item => {
        if (item.company !== null && item.company !== '') {
          companySet.add(item.company);
        }
      });
      regionAccountInfo.data.forEach(item => {
        if (item.region !== null && item.region !== '') {
          regionSet.add(item.region);
        }
      });
      // region dropdown
      let tempRegionObjects = {};
      this.regionListForSearch = [];
      regionSet.forEach(it => {
        tempRegionObjects[it] = it;
      });
      let regionForAll = {
        regionValue: '',
        regionName: '<ALL>'
      };
      this.regionListForSearch.push(regionForAll);
      Object.keys(tempRegionObjects).sort().forEach(item => {
        let region = {
          regionValue: item,
          regionName: item
        };
        this.regionListForSearch.push(region);
      });
      if (this.regionListForSearch.length === 2) {
        this.vendorSearchInfo.region = this.regionListForSearch[1].regionValue;
      }
      // company dropdown
      let tempCompanyObjects = {};
      this.companyListForSearch = [];
      companySet.forEach(it => {
        tempCompanyObjects[it] = it;
      });
      let companyForAll = {
        companyValue: '',
        companyName: '<ALL>'
      };
      this.companyListForSearch.push(companyForAll);
      Object.keys(tempCompanyObjects).sort().forEach(item => {
        let company = {
          companyValue: item,
          companyName: item
        };
        this.companyListForSearch.push(company);
      });
      if (this.companyListForSearch.length === 2) {
        this.vendorSearchInfo.company = this.companyListForSearch[1].companyValue;
      }
      // gsid dropdown
      this.regionAccount.data.forEach(item => {
        if (item.gsid !== '') {
          gsidMap.set(item.gsid, item.name);
        }
      });
      let gsidForAll = {
        gsidValue: '',
        gsidName: '<ALL>'
      };
      this.gsidListForSearch = [];
      let gsidListSort = [];
      this.gsidListForSearch.push(gsidForAll);
      gsidMap.forEach((name, value) => {
        let gsid = {
          gsidValue: value,
          gsidName: name
        };
        gsidListSort.push(gsid);
      });
      gsidListSort.sort(this.compareByGsidName()); // sort by name
      gsidListSort.forEach(item => {
        this.gsidListForSearch.push(item);
      })
      if (this.gsidListForSearch.length === 2) {
        this.vendorSearchInfo.gsid = this.gsidListForSearch[1].gsidValue;
      }
      // category dropdown
      let categoryForAll = {
        categoryId: '',
        categoryName: '<ALL>'
      };
      let categoryData = this.vendorCategory
      this.categoryListForSearch = [];
      let categoryListSort = [];
      this.categoryListForSearch.push(categoryForAll);
      categoryData.data.forEach(item => {
        if (item.categoryName !== null && item.categoryName !== '') {
          categoryMap.set(item.id, item.categoryName);
        }
      });
      categoryMap.forEach((name, value) => {
        let category = {
          categoryId: value,
          categoryName: name
        };
        categoryListSort.push(category);
      });
      categoryListSort.sort(this.compareByCategoryName()); // sort by name
      categoryListSort.forEach(item => {
        this.categoryListForSearch.push(item);
      })
    },
    compareByCategoryName () {
      return function (a, b) {
        let value1 = a.categoryName;
        let value2 = b.categoryName;
        if (value1 < value2) {
          return -1;
        } else if (value1 > value2) {
          return 1;
        } else {
          return 0;
        }
      }
    },
    compareByGsidName () {
      return function (a, b) {
        let value1 = a.gsidName.substring(0, a.gsidName.indexOf('('));
        let value2 = b.gsidName.substring(0, b.gsidName.indexOf('('));
        if (value1 < value2) {
          return -1;
        } else if (value1 > value2) {
          return 1;
        } else {
          return 0;
        }
      }
    },
    compareByCompanyName () {
      return function (a, b) {
        let value1 = a.companyName;
        let value2 = b.companyName;
        if (value1 < value2) {
          return -1;
        } else if (value1 > value2) {
          return 1;
        } else {
          return 0;
        }
      }
    },
    compareByRegionName () {
      return function (a, b) {
        let value1 = a.regionName;
        let value2 = b.regionName;
        if (value1 < value2) {
          return -1;
        } else if (value1 > value2) {
          return 1;
        } else {
          return 0;
        }
      }
    },
    handleSaveVendor () {
      this.$refs.updateForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.saveVendorInfo();
        }
      });
    },
    async initCategoryData (categoryInfo) {
      this.categoryObjectList = [];
      this.categoryObjects = {};
      let categoryMap = new Map();
      categoryInfo.data.forEach(item => {
        if (item.categoryName !== null && item.categoryName !== '') {
          categoryMap.set(item.id, item.categoryName);
        }
      });
      categoryMap.forEach((item, index) => {
        let category = {};
        category.categoryId = index;
        category.categoryName = item;
        this.categoryObjectList.push(category);
      });
    },
    async initRegionAccountData (regionAccountInfo) {
      this.companyObjectList = [];
      this.companyObjects = {};
      this.requiredObjectList = [];
      this.requiredObjects = {};
      let companyMap = new Map();
      regionAccountInfo.data.forEach(item => {
        if (item.company !== '') {
          companyMap.set(item.company, item.company);
        }
      });
      companyMap.forEach((item, index) => {
        let company = {};
        company.companyValue = index;
        company.companyName = item;
        this.companyObjectList.push(company);
      });
      this.companyObjectList.sort(this.compareByCompanyName());
      for (let i = 0; i < 2; i++) {
        let required = {};
        required.requiredValue = i;
        if (i === 0) {
          required.requiredName = 'NO';
        } else {
          required.requiredName = 'YES';
        }
        this.requiredObjectList.push(required);
      }
    },
    getRegion (company) { // getAllRegion
      this.regionObjectList = [];
      this.regionObjects = {};
      let regionMap = new Map();
      this.regionAccount.data.forEach(item => {
        if (item.region !== '' && item.company === company) {
          regionMap.set(item.region, item.region);
        }
      });
      regionMap.forEach((item, index) => {
        let region = {};
        region.regionValue = index;
        region.regionName = item;
        this.regionObjectList.push(region);
      });
      this.regionObjectList.sort(this.compareByRegionName());
    },
    getGsid (company, region) { // getAllGsid
      this.gsidObjectList = [];
      this.gsidObjects = {};
      let gsidMap = new Map();
      this.regionAccount.data.forEach(item => {
        if (item.gsid !== '' && item.region === region && item.company === company) {
          gsidMap.set(item.gsid, item.name);
        }
      });
      gsidMap.forEach((item, index) => {
        let gsid = {};
        gsid.gsidValue = index;
        gsid.gsidName = item;
        this.gsidObjectList.push(gsid);
      });
      this.gsidObjectList.sort(this.compareByGsidName()); // sort by name
    },
    chooseCompany (e) {
      let that = this;
      this.regionObjectList = [];
      this.regionObjects = {};
      this.gsidObjectList = [];
      this.gsidObjects = {};
      if (!this.modifyFlag) {
        this.updateVendorInfo.region = '';
        this.updateVendorInfo.gsid = '';
      }
      for (var index2 in that.companyObjectList) {
        if (e === that.companyObjectList[index2].companyValue) {
          this.getRegion(e)
          if (!this.modifyFlag) {
            this.updateVendorInfo.region = this.regionObjectList[0].regionValue;
          }
          this.chooserRegion(this.updateVendorInfo.region);
        }
      }
    },
    chooserRegion (e) {
      let that = this;
      this.gsidObjectList = [];
      this.gsidObjects = {};
      if (!this.modifyFlag) {
        this.updateVendorInfo.gsid = '';
      }
      for (var index2 in that.regionObjectList) {
        if (e === that.regionObjectList[index2].regionValue) {
          this.getGsid(this.updateVendorInfo.company, e)
          if (!this.modifyFlag) {
            this.updateVendorInfo.gsid = this.gsidObjectList[0].gsidValue;
          }
          this.chooserGsid(this.updateVendorInfo.gsid);
        }
      }
    },
    chooserGsid (e) {
      this.updateVendorInfo.gsid = e;
      this.modifyFlag = false;
      this.$forceUpdate();
    },
    chooserRequired (e) {
      this.updateVendorInfo.required = e;
      this.$forceUpdate();
    },
    async saveVendorInfo () {
      this.$loading({fullscreen: true});
      let responseData = await saveVendorInfo(this.updateVendorInfo);
      if (responseData.code === Constant.RESPONSE_SUCCESS_CODE) {
        this.vendorInfoList = [];
        this.pageSize = 20;
        this.currentPage = 1;
        this.vendorSearchInfo = {
          pageSize: 20,
          currentPage: 1,
          vendorCode: '',
          vendorName: '',
          contactPerson: '',
          email: '',
          categoryId: '',
          region: '',
          company: '',
          gsid: '',
          required: ''
        };
        sessionStorage.setItem(Constant.VENDOR_SEARCH_CONDITIONS, JSON.stringify(this.vendorSearchInfo));
        this.callSearchInfo();
        this.callVendorInfo();
        this.$message.success(Constant.SAVE_SUCCEED);
      }
      this.dialogVisible = false;
      this.updateVendorInfo = {};
      this.$loading({fullscreen: true}).close();
    },
    // get the user selected's data
    handleSelectionChange (value) {
      this.multipleSelection = value;
    },
    handleRowDBClick (row, event) {
      this.dialogTitle = 'Modify Vendor';
      this.updateVendorInfo = JSON.parse(JSON.stringify(row));
      this.updateVendorInfo.required = this.updateVendorInfo.required === true ? 1 : 0;
      if (this.updateVendorInfo.esgVendorRegionalAccounts != null) {
        this.updateVendorInfo.company = this.updateVendorInfo.esgVendorRegionalAccounts.company;
        this.updateVendorInfo.region = this.updateVendorInfo.esgVendorRegionalAccounts.region;
        if (this.updateVendorInfo.esgVendorRegionalAccounts.esgStaffInfo != null) {
          this.updateVendorInfo.gsid = this.updateVendorInfo.esgVendorRegionalAccounts.esgStaffInfo.staffId;
        }
      }
      this.modifyFlag = true;
      this.chooseCompany(this.updateVendorInfo.company); // let associated staff to display displayName
      this.dialogVisible = true;
    },
    showAddDialog () {
      this.dialogTitle = 'Add Vendor';
      this.dialogVisible = true;
      this.updateVendorInfo = {};
      this.updateVendorInfo.company = this.companyObjectList[0].companyValue; // dafault the list first
      this.updateVendorInfo.required = this.requiredObjectList[1].requiredValue;
      this.chooseCompany(this.updateVendorInfo.company);
      this.chooserRequired(this.updateVendorInfo.required)
    },
    showModifyDialog () {
      if (this.multipleSelection.length === 1) {
        this.dialogTitle = 'Modify Vendor';
        this.updateVendorInfo = JSON.parse(JSON.stringify(this.multipleSelection[0]));
        this.updateVendorInfo.required = this.updateVendorInfo.required === true ? 1 : 0;
        if (this.updateVendorInfo.esgVendorRegionalAccounts != null) {
          this.updateVendorInfo.company = this.updateVendorInfo.esgVendorRegionalAccounts.company;
          this.updateVendorInfo.region = this.updateVendorInfo.esgVendorRegionalAccounts.region;
          if (this.updateVendorInfo.esgVendorRegionalAccounts.esgStaffInfo != null) {
            this.updateVendorInfo.gsid = this.updateVendorInfo.esgVendorRegionalAccounts.esgStaffInfo.staffId;
          }
          this.modifyFlag = true;
          this.chooseCompany(this.updateVendorInfo.company);
        }
        this.dialogVisible = true;
      } else {
        if (this.multipleSelection.length === 0) {
          this.$message.warning(Constant.SELECT_NONE_LINE);
        } else {
          this.$message.warning(Constant.SELECT_MULTIPLE_LINES);
        }
      }
    },
    handleCancelBtn () {
      this.dialogVisible = false;
      this.$refs.updateForm.resetFields();
    },
    searchValidateAndCall () {
      this.pageSize = 20;
      this.currentPage = 1;
      this.vendorSearchInfo.pageSize = 20;
      this.vendorSearchInfo.currentPage = 1;
      this.$refs.searchForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          sessionStorage.setItem(Constant.VENDOR_SEARCH_CONDITIONS, JSON.stringify(this.vendorSearchInfo));
          this.callSearchInfo();
        }
      });
    },
    async callSearchInfo () {
      this.loadingStatus = true;
      let vendorSearchInfo = JSON.parse(sessionStorage.getItem(Constant.VENDOR_SEARCH_CONDITIONS));
      let vendorData = await findVendorInfoByConditions(vendorSearchInfo);
      this.totalCount = vendorData.data.totalCount;
      if (vendorData.data.esgVendors != null && vendorData.data.esgVendors.length !== 0) {
        this.initPageData(vendorData.data.esgVendors);
      } else {
        this.vendorInfoList = [];
      }
      this.loadingStatus = false;
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.vendorSearchInfo = JSON.parse(sessionStorage.getItem(Constant.VENDOR_SEARCH_CONDITIONS));
      this.vendorSearchInfo.pageSize = val;
      sessionStorage.setItem(Constant.VENDOR_SEARCH_CONDITIONS, JSON.stringify(this.vendorSearchInfo));
      this.callSearchInfo();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.vendorSearchInfo = JSON.parse(sessionStorage.getItem(Constant.VENDOR_SEARCH_CONDITIONS));
      this.vendorSearchInfo.currentPage = val;
      sessionStorage.setItem(Constant.VENDOR_SEARCH_CONDITIONS, JSON.stringify(this.vendorSearchInfo));
      this.callSearchInfo();
    },
    // upload
    validateFileType (file) {
      const extension = file.name.split('.')[1] === 'xls';
      const extension2 = file.name.split('.')[1] === 'xlsx';
      if (!extension && !extension2) {
        this.$message.error('Only Excel File is Allowed.');
        return false;
      } else {
        return true;
      }
    },
    async submitUpload () {
      if (this.fileList.length === 0) {
        this.$alert(Constant.SUBMIT_NO_FILE, 'Warning', {
          confirmButtonText: 'OK'
        });
        return;
      } else if (this.fileList.length > 1) {
        this.$alert(Constant.SUBMIT_MULTIPLE_FILES, 'Warning', {
          confirmButtonText: 'OK'
        });
        return;
      }
      this.$refs.upload.submit();
      this.uploadDialogVisible = false;
    },
    async exportTableData () {
      if (this.totalCount < 1) {
        this.totalCount = 1;
      }
      this.$loading({fullscreen: true});

      let vendorSearchInfo = JSON.parse(sessionStorage.getItem(Constant.VENDOR_SEARCH_CONDITIONS));
      let vendorList;

      // no need pageable, will export all search data
      vendorSearchInfo.pageSize = this.totalCount;
      vendorSearchInfo.currentPage = 1;
      if (this.userType === this.regionVendor) {
        vendorList = await findVendorInfoByConditions(vendorSearchInfo, this.userName);
      } else {
        vendorList = await findVendorInfoByConditions(vendorSearchInfo, '');
      }
      require.ensure([], () => {
        const { exportJsonToExcel } = require('@/utils/Export2Excel');
        let tHeader = ['ID', 'Vendor Code', 'Vendor Name', 'Contact Person', 'Vendor Email', 'Category', 'Region', 'Associate Staff', 'Company', 'Active', 'Last Updated By', 'Last Updated Date'];
        let filterVal = ['id', 'vendorCode', 'vendorName', 'contactPerson', 'email', 'categoryName', 'region', 'displayName', 'company', 'required', 'modifiedBy', 'modifiedDate'];
        let sheet = [];
        // deep clone
        let exportVendorList = JSON.parse(JSON.stringify(vendorList.data));
        // format data in key-value
        exportVendorList.esgVendors.forEach(item => {
          let row = [];
          row[filterVal[0]] = item.id;
          row[filterVal[1]] = item.vendorCode;
          row[filterVal[2]] = item.vendorName;
          row[filterVal[3]] = item.contactPerson;
          row[filterVal[4]] = item.email;
          row[filterVal[5]] = item.esgVendorCategory.categoryName;
          row[filterVal[6]] = item.esgVendorRegionalAccounts.region;
          row[filterVal[7]] = item.esgVendorRegionalAccounts.esgStaffInfo.displayName;
          row[filterVal[8]] = item.esgVendorRegionalAccounts.company;
          row[filterVal[9]] = item.required === '1' ? 'YES' : 'NO';
          row[filterVal[10]] = item.modifiedBy;
          row[filterVal[11]] = CommonHelper.formatDate(item.modifiedDate);
          sheet.push(row);
        });

        let data = this.formatJson(filterVal, sheet);
        exportJsonToExcel(tHeader, data, 'VendorList');
      });
      this.$loading({fullscreen: true}).close();
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleRemove (file, fileList) {
      this.fileList = fileList;
    },
    handlePreview (file) {
      console.log(file);
    },
    handleChange (file, fileList) {
      this.fileList = fileList;
      this.$loading({fullscreen: true}).close();
    },
    handleExceed (file, fileList) {
      this.$message.warning(Constant.SELECT_MUTILPLE_FILES);
    },
    handleOnProgress (event, file, fileList) {
      this.$loading({fullscreen: true});
    },
    handleSuccess (response, file, fileList) {
      if (response.code === Constant.POPUP_EXCEPTION_CODE && response.msg !== '') {
        this.$alert(response.msg, 'Warning', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'OK',
          callback: action => {
            this.resetPage();
          }
        });
      } else if (response.code === Constant.RESPONSE_SYSTEMERROR_CODE) {
        this.$message.error(response.msg);
      } else {
        this.$alert('Upload success!', 'Tips', {
          confirmButtonText: 'OK'
        });
        this.resetPage();
      }
      this.$refs.upload.clearFiles();
    },
    handleError (response) {
      CommonHelper.handleExceptionForComponentRequest(response);
    },
    closeDialog () {
      this.dialogVisible = false;
      this.updateVendorInfo = {};
      this.$refs.updateForm.resetFields();
    },
    async verifyUser () {
      let user = await verifyUserInfo();
      this.userName = user.domain;
      this.userType = user.role;
    },
    resetPage () {
      this.vendorInfoList = [];
      this.pageSize = 20;
      this.currentPage = 1;
      this.vendorSearchInfo = {
        pageSize: 20,
        currentPage: 1,
        vendorCode: '',
        vendorName: '',
        email: '',
        region: '',
        applicant: '',
        company: ''
      };
      this.vendorSearchInfo.region = '';
      this.vendorSearchInfo.gsid = '';
      this.vendorSearchInfo.required = '';
      this.vendorSearchInfo.categoryId = '';
      sessionStorage.setItem(Constant.VENDOR_SEARCH_CONDITIONS, JSON.stringify(this.vendorSearchInfo));
      this.callVendorInfo();
      this.callSearchInfo();
    }
  },
  created () {
    this.verifyUser();
  },
  mounted () {
    sessionStorage.setItem(Constant.VENDOR_SEARCH_CONDITIONS, JSON.stringify(this.vendorSearchInfo));
    this.callVendorInfo().then(value => {
      this.callSearchInfo();
    });
  },
  beforeDestroy () {
    this.$loading({fullscreen: true}).close();
  }
};
</script>

<style scoped>
.text-align-left {
  text-align: left;
}

.page-title{
  font-size: 20px;
  margin-top: 80px;
}
.margin-top{
    margin-top: 30px;
}
.margin-bottom{
  margin-bottom: 45px;
}
.line {
  width: 1px;
  height: 700px;
  background-color: #e6e6e6;
  margin-left: 20px;
}

.vendor-table{
    margin-top: 15px;
}

.table-nav{
    position: fixed;
    bottom: 40px;
}

>>>.search-btn{
    margin-top: 20px!important;
    width: 200px;
}

/*rewrite element-ui */

>>>.dialog-form .el-input{
  width: 360px;
}

>>>.el-dialog__footer {
    padding: 40px 70px 20px;
}
>>>.el-button{
    border-color: #5e89ed;
    color: #5e89ed;
}

>>>.el-button:hover{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
}

>>>.el-button:focus{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
}

>>>.el-button--danger{
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
}

>>>.el-button--danger:hover{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
}

>>>.el-button--danger:focus{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
}

>>>.el-table{
  color: black;
}

>>>.el-table thead{
  color: black;
}

>>>.el-form--label-top .el-form-item__label{
    padding: 0;
}

>>>.el-form-item{
    margin-bottom: 5px;
}

>>>.el-pager li.active{
    color: #5e89ed;
}

>>>.el-pager li:hover{
    color: #5e89ed;
}

>>>.el-checkbox__inner{
    border: 1px solid #aaaaaa;
}

>>>.el-form-item__label{
    line-height: 32px;
}

.el-dialog__body{
  padding: 5px 70px;
}

.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #5e89ed;
  border-color: #5e89ed;
}
</style>
<style>
  .el-input{
    margin-top: 0;
    width: 200px;
  }
  .el-dialog__body{
    padding: 5px 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/VendorMaintenance.vue